import * as z from "zod";

export const AddressSchema = z.object({
  street: z.string().nullable(),
  addressLine2: z.string().nullable(),
  city: z.string().nullable(),
  state: z.string().nullable(),
  zipCode: z.string().nullable(),
  countryId: z.number(),
});

export const OrganizationSchema = z.object({
  id: z.number(),
  name: z.string(),
  isActive: z.boolean(),
  address: AddressSchema.nullable(),
});

export type Organization = z.infer<typeof OrganizationSchema>;
